var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"font-weight-bold text-right mb-0"},[_vm._v("ผ่านไปแล้ว: "+_vm._s(_vm.elapsedTime))])}
var staticRenderFns = []

export { render, staticRenderFns }